import React, { useState } from 'react';
import { ChevronUp } from 'react-feather';
import { font_h4, font_h5, handCursor } from '../../Constant/constant';
import { FlexCol, FlexRow, HighlightText } from '../../Styles';
import Jump from 'react-reveal/Jump';
import "./index.css";

const Footer = () => {
    const color = "#05245f";

    const [Animate, setAnimate] = useState(false);

    const scrollToTop = () => {
        window.scrollTo(0, 0);
    }

    return (
        <FlexRow onMouseEnter={() => { if (!Animate) { setAnimate(true) } }} style={{ background: '#1f9ac1', margin: 'auto', minHeight: 10, width: '99%', padding: '10px 0', marginTop: 180, textAlign: 'center', fontWeight: 500 }}>
            <FlexCol basis="60%" style={{
                color: 'white',
                position: 'absolute',
                top: '-84px',
                lineHeight: '0.5',
                fontSize: font_h4,
                mixBlendMode: 'color-dodge',
                filter: 'opacity(0.4)',
                cursor: handCursor
            }} onClick={() => scrollToTop()}>
                <Jump spy={Animate} count={30}>
                    <ChevronUp size="56" color={'aliceblue'} /><br />
                </Jump>
                back to top
            </FlexCol>
            <FlexCol basis="60%" className="footer-title">
                {'STEVEN</>FERNANDES'}
            </FlexCol>
            <FlexCol basis="60%" style={{ color: color }}>Are you interested in a project. Lets talk.</FlexCol>
            <FlexCol basis="60%" className="email-space" onClick={() => window.open('mailto:stevenfernz96@gmail.com')}>
                Stevenfernz96@gmail.com
            </FlexCol>
            <FlexCol>
                <FlexRow className="socialLinks" style={{ minHeight: 64, marginTop: '8px' }}>
                    <FlexCol onClick={() => window.open("mailto:stevenfernz96@gmail.com")} basis="12%" style={{ color: color, fontSize: font_h5, fontWeight: 300, cursor: 'url(https://cdn.custom-cursor.com/db/pointer/32/Gray_pointer.png),auto' }}>GMAIL</FlexCol>
                    <FlexCol onClick={() => window.open("https://www.instagram.com/nevetsegghead/")} basis="14%" style={{ color: color, fontSize: font_h5, fontWeight: 300, cursor: 'url(https://cdn.custom-cursor.com/db/pointer/32/Gray_pointer.png),auto' }}>INSTAGRAM</FlexCol>
                    <FlexCol onClick={() => window.open("https://www.facebook.com/steven.ferns.750/")} basis="12%" style={{ color: color, fontSize: font_h5, fontWeight: 300, cursor: 'url(https://cdn.custom-cursor.com/db/pointer/32/Gray_pointer.png),auto' }}>FACEBOOK</FlexCol>
                    <FlexCol onClick={() => window.open("https://www.linkedin.com/in/steven-fernandes-5b80b3187/")} basis="12%" style={{ color: color, fontSize: font_h5, fontWeight: 300, cursor: 'url(https://cdn.custom-cursor.com/db/pointer/32/Gray_pointer.png),auto' }}>LINKEDIN</FlexCol>
                    <FlexCol onClick={() => window.open("https://github.com/stark1996")} basis="12%" style={{ color: color, fontSize: font_h5, fontWeight: 300, cursor: 'url(https://cdn.custom-cursor.com/db/pointer/32/Gray_pointer.png),auto' }}>GITHUB</FlexCol>
                    <FlexCol onClick={() => window.open("https://twitter.com/KuroNevets")} basis="12%" style={{ color: color, fontSize: font_h5, fontWeight: 300, cursor: 'url(https://cdn.custom-cursor.com/db/pointer/32/Gray_pointer.png),auto' }}>TWITTER</FlexCol>
                </FlexRow>
            </FlexCol>

            <FlexCol basis="60%" style={{ color: color, marginTop: '80px', fontSize: 14 }}>Handcrafted by Me © 2021</FlexCol>
            <FlexCol basis="60%" style={{ color: color, textAlign: 'center', fontSize: 14 }}>
                Made with <br />
                ReactJS and <HighlightText style={{ color: '#2B0033', fontWeight: 600 }}>{'<Heart />'}</HighlightText>
            </FlexCol>
        </FlexRow>
    );
}

export default Footer;
